import { render, staticRenderFns } from "./addAudioVant.vue?vue&type=template&id=0b608a2d&"
import script from "./addAudioVant.vue?vue&type=script&lang=js&"
export * from "./addAudioVant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports